export default __webpack_public_path__ + "static/media/board6.49d940eb.jpg";